import { FormState, FormValidationFunction } from '@Shared/Components/Forms/FormElement.types'
import { TextInputValidationFn } from '@Shared/Components/Inputs/TextInput/TextInput'

export const PhoneLengthValidation: (min?: number, max?: number) => FormValidationFunction<unknown> = (min = 6, max?: number) => (value, t) => {
  const withinLimit = max ? `${value}`.length <= max : true
  if (`${value}`.length >= min && /^-?\d+$/.test(`${value}`) && withinLimit) {
    return { state: FormState.VALID }
  }
  return {
    message: t('checkout:COF_PHONE_NUMBER_IS_INVALID'),
    state: FormState.ERROR,
  }
}

export const PhoneLengthValidationV2: (t, min?: number, max?: number) => TextInputValidationFn = (t, min = 6, max?: number) => (value) => {
  const withinLimit = max ? `${value}`.length <= max : true
  if (`${value}`.length >= min && /^-?\d+$/.test(`${value}`) && withinLimit) {
    return { success: true, errorMessage: '' }
  }
  return {
    errorMessage: t('checkout:COF_PHONE_NUMBER_IS_INVALID'),
    success: false,
  }
}
